// extracted by mini-css-extract-plugin
export default {"Display":"calender_Display__4JgF6","text":"calender_text__O1VbT","input":"calender_input__V+AYM","button":"calender_button__M6STA"};